// TODO refactor this file to use angular

'use strict';

var searchSuggestList = [];

function clearSearch() {
    jQuery('.search-panel').hide();
    jQuery('#searchSuggestions').hide();
    closeSearch();
    jQuery('#searchPhrase')
        .val('')
        .trigger('blur');
}

function closeSearch() {
    if (!jQuery('#searchPhrase').val().match(/\w/g)) {
        jQuery('#searchForm').removeClass('ready');
    }
}

function escSearch(e) {
    switch (e.keyCode) {
        case 27:
        clearSearch();
        break;
        case 38: // up arrow
        focusPrevSuggestion(e); // method in 2013-suggestive-search.js
        break;
        case 40: // down arrow
        focusNextSuggestion(e); // method in 2013-suggestive-search.js
        break;
    }
}

function focusNextSuggestion(e) {
    e.preventDefault();

    if (jQuery('#searchSuggestions .suggest.focus').length > 0) {
        if (jQuery('#searchSuggestions .suggest').last().hasClass('focus')) {
            jQuery('#searchSuggestions .suggest.focus').removeClass('focus');
            jQuery('#searchPhrase').focus();
        } else {
            jQuery('#searchSuggestions .suggest.focus')
                .removeClass('focus')
                .nextAll('.suggest')
                .first()
                .addClass('focus')
                .find('a')
                .focus();
        }
    } else {
        jQuery('#searchSuggestions .suggest')
            .eq(0)
            .addClass('focus')
            .find('a')
            .focus();
    }
}

function focusPrevSuggestion(e) {
    e.preventDefault();

    if (jQuery('#searchSuggestions .suggest.focus').length > 0) {
        if (jQuery('#searchSuggestions .suggest').eq(0).hasClass('focus')) {
            jQuery('#searchSuggestions .suggest.focus').removeClass('focus');
            jQuery('#searchPhrase').focus();
        } else {
            jQuery('#searchSuggestions .suggest.focus').removeClass('focus').prevAll('.suggest').first().addClass('focus').find('a').focus();
        }
    } else {
        jQuery('#searchSuggestions .suggest').last().addClass('focus').find('a').focus();
    }
}

function hideSuggestions() {
    jQuery('.search-panel').slideUp();
    jQuery('#searchSuggestions').hide();
}

function keyThroughList(e) {
    switch (e.keyCode) {
        case 8: // backspace
        jQuery('#searchSuggestions li.focus').removeClass('focus').find('a').blur();
        jQuery('#searchPhrase').focus();
        break;
        case 27: // esc
        jQuery('#searchPhrase').val('').blur();
        jQuery('#searchSuggestions').hide().find('li.focus').removeClass('focus');
        break;
        case 37: //left arrow
        jQuery('#searchPhrase').focus();
        break;
        case 38: // up arrow
        focusPrevSuggestion(e);
        break;
        case 39: //right arrow
        jQuery('#searchPhrase').val(jQuery('#searchSuggestions li.focus a').text()).focus();
        break;
        case 40: // down arrow
        focusNextSuggestion(e);
        break;
    }
}

function keyToOpenSearch(e) {
    openSearch();
    jQuery('#searchPhrase').val(jQuery('#searchPhrase').val() + String.fromCharCode(e.keyCode));
}

function keyToSearch(e) {
    var activeTag = document.activeElement.nodeName.toLowerCase();
    var keysThatInitSearch = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90]; // numbers and letters

    if (!e.altKey && !e.ctrlKey && !e.metaKey) {
        if (activeTag !== 'input' && activeTag !== 'textarea') {
            if (jQuery.inArray(e.keyCode, keysThatInitSearch) >= 0) {
                keyToOpenSearch(e);
            }
        }
    }

    if (e.keyCode === 27) {
        clearSearch();
    }
}

function openSearch() {
    jQuery('#searchForm').addClass('ready');
    jQuery('#searchPhrase').trigger('focus');
}

function scrollToPosition(pos) {
    jQuery('html, body').animate({
        'scrollTop': pos - jQuery('.global-header').height() - 10
    }, 'fast');
}

function search() {
    var term = jQuery(this).val();
    var jsonpScript = document.createElement('script');

    jQuery('.search-panel').show();
    jQuery('#searchSuggestions').show();

    $.ajax({
        url: window.location.protocol + '//query.published.live1.suggest.us1.fredhopperservices.com/anthropologie/jscript?scope=//catalog01/en_US&search=' + term,
        dataType: 'jsonp',
        success: searchCallback
    });
}

function searchCallback(jsonResponse) {
    var $element = jQuery('#searchSuggestions');
    var searchVal = jQuery('#searchPhrase').val();

    jQuery('.search-panel').hide();
    $element.html('').hide();
    jQuery.each(jsonResponse.suggestionGroups, function(i, suggestionGroup) {
        jQuery.each(suggestionGroup.suggestions, function(j, suggestions) {
            searchSuggestList.push(suggestions.searchterm);
        });
    });

    if (searchSuggestList.length > 0) {
        jQuery('.search-panel').show();
        $element.show();

        // insert fredhopper "popular" search list
        $element.append('<li class="group-header">Popular searches</li>');
        jQuery.each(searchSuggestList, function(i, el) {
            jQuery('<li/>')
                .html('<a href="' + window.localeWithLanguage + '/search/search.jsp?searchPhrase=' + el.replace(/\W+/g, '+') + '">' + el + '</a>')
                .addClass('suggest')
                .on({
                    'keydown': keyThroughList
                })
                .appendTo($element);
        });
    }

    var $onThisPage = jQuery('.item-description a').filter(function() {
        return jQuery(this)
            .text()
            .toLowerCase()
            .match(searchVal.toLowerCase());
    });

    if ($onThisPage.length > 0) {
        $element.show();

        // insert "on this page" search list
        $element.append('<li class="group-header on-this-page">On this page</li>');
        $onThisPage.each(function(i, el) {
            var $pageLi;
            if (i < jQuery('#searchPhrase').attr('data-results')) {
                $pageLi = jQuery('<li/>');
                $pageLi
                    .html('<a href="javascript:scrollToPosition(' + jQuery(el).closest('.category-item').offset().top + ');">' + jQuery(el).text() + '</a>')
                    .addClass('suggest')
                    .on({
                        'keydown': keyThroughList
                    })
                    .appendTo($element);
            } else {
                return false;
            }
        });
    }

    searchSuggestList.splice(0, searchSuggestList.length);
}

function suggestiveLocation() {
    jQuery('#searchForm').on({
        'click': openSearch
    });

    jQuery('#searchPhrase').on({
        'keydown': escSearch,
        'keyup': search
    });

    jQuery('.below-header').on({
        'click': closeSearch
    });

    jQuery('#main-container, #header-container, .i18n-currency, .hon_account').on({
        'click': hideSuggestions
    });
}

module.exports = /*@ngInject*/
function() {
    return {
        closeSearch: closeSearch,
        hideSuggestions: hideSuggestions,
        suggestiveLocation: suggestiveLocation
    };
};
